import { createFileRoute } from '@tanstack/react-router';

import { NotesPage } from '~pages/notes/notes-page';

export const Route = createFileRoute('/_auth/_layout/students/$studentId/notes')({
  component: RouteComponent,
});

function RouteComponent() {
  const { studentId } = Route.useParams();

  return <NotesPage studentId={studentId} />;
}
